document.addEventListener("DOMContentLoaded", function () {
    console.log("DOMContentLoaded");

    function handleProductBlocks() {
        const kgProductVariantContentEleArr = document.querySelectorAll(".kg-product-block");

        kgProductVariantContentEleArr.forEach(function (kgProductVariantContentEle) {

            const kgHideColorSwatchEle = kgProductVariantContentEle.querySelector(
                "variant-swatch-king [option-name='Color']"
            );

            const kgCombinedListingEle = kgProductVariantContentEle.querySelector(
                "variant-king-combined-listing .swatches.swatches-type-products"
            );

            console.log(kgCombinedListingEle, "observer check");

            if (
                kgCombinedListingEle &&
                kgCombinedListingEle.innerHTML.trim() !== "" &&
                kgHideColorSwatchEle
            ) {
                kgHideColorSwatchEle.style.display = "none";
            }
        });
    }

    // Run initially
    handleProductBlocks();

    // Create observer
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function () {
            handleProductBlocks();
        });
    });

    // Observe whole body (or narrow it if possible for performance)
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});
